import type { Day, POI } from '@poi-planner/shared';

interface WakeUpIndicatorProps {
  dayIndex: number;
  day: Day;
  previousDay: Day | null;
  getAccommodation: (id: string) => POI | undefined;
}

export function WakeUpIndicator({ dayIndex, day, previousDay, getAccommodation }: WakeUpIndicatorProps) {
  let label = 'Wake Up';
  let description = 'Start from home';

  if (dayIndex > 0 && previousDay?.sleep) {
    const prevAccom = getAccommodation(previousDay.sleep.poiId);
    const prevAccomName = prevAccom?.name ?? 'Unknown';
    const currentSleepId = day.sleep?.poiId;
    const isCheckout = previousDay.sleep.poiId !== currentSleepId;

    label = 'Wake Up In';
    description = isCheckout ? `${prevAccomName} (Checkout)` : prevAccomName;
  }

  return (
    <div className="indicator-wake">
      <span className="material-symbols-outlined text-wake-accent text-lg">
        wb_sunny
      </span>
      <div className="flex flex-col">
        <span className="text-[10px] font-bold text-orange-600 uppercase tracking-wide">
          {label}
        </span>
        <span className="text-xs font-medium text-wake-text">
          {description}
        </span>
      </div>
    </div>
  );
}
